// extracted by mini-css-extract-plugin
export default {"cardContainer":"style_cardContainer__YHCPQ","title":"style_title__Bujof","date":"style_date__mx3UF"};